import {invokeConversionFunction, mergeArray} from '../VariableConversion';

class JSONPathParserHelper {

    constructor(options) {
        this.options = options;
    }

	// eslint-disable-next-line max-params
    processFunction(func, list, currentPointer, content) {
        let args = func.args;
        let result = [];
        for (let arg of args) {
            let res = this.processCommands([arg], currentPointer, content);
            if (res !== null) {
                result.push(res);
            }
        }

        if (func.func === "join") {
            result = [result];
        } else if (func.func === "array") {
            result = [result];
        } else {
            result = mergeArray(result);
        }
        return invokeConversionFunction(func.func, result);
    }

    processCommands(list, currentPointer, content) {
        if (list.length === 0) {
            return currentPointer;
        }

        let rule = list.shift();

        if (currentPointer === null || currentPointer === undefined) {
            return null;
        }

        if (rule.expression !== undefined) {
            let result = null;
            if (rule.expression.startsWith("\"") || rule.expression.startsWith("'")) {
                result = rule.expression.substring(1);
            }
            if (result !== null && (result.endsWith("\"") || result.endsWith("'"))) {
                result = result.substring(0, result.length - 1);
            } else {
                result = null;
            }

            if (result !== null) {
                // is static value
                return result;
            } else {
                // it isn't static value
            }
        }

        if (rule.func !== undefined && rule.args !== undefined) {
            return this.processFunction(rule, list, currentPointer, content);
        }

        if (rule.property !== undefined && rule.value !== undefined) {
            return this.processMultiSelection(rule, list, currentPointer, content);
        }

        if (rule.selections !== undefined) {
            return this.processMultiSelection(rule, list, currentPointer, content);
        }

        if (rule.names !== undefined) {
            return this.processCommands([...rule.names], currentPointer, content);
        }

        let ruleName = rule.name;

        let output = [];
        if (Array.isArray(ruleName)) {
            for (let idx = 0; idx < ruleName.length; idx++) {
                let cur = ruleName[idx].trim().split(".");
                if (Array.isArray(cur) && cur.length === 1) {
                    cur = cur[0];
                }

                if (Array.isArray(cur)) {
                    let newCurrentPointer = currentPointer;
                    for (let idy = 0; idy < (cur.length - 1); idy++) {
                        newCurrentPointer = newCurrentPointer[cur[idy]]; // nosemgrep
                        if (newCurrentPointer === undefined) {
                            break;
                        }
                    }
                    if (newCurrentPointer !== undefined) {
                        let val = this.processRuleName(cur[cur.length - 1], rule, [...list], newCurrentPointer, content);
                        if (val !== null) {
                            output.push(this.extractTextValue(val));
                        }
                    }
                } else {
                    let val = this.processRuleName(cur, rule, [...list], currentPointer, content);
                    if (val !== null) {
                        output.push(this.extractTextValue(val));
                    }
                }
            }
        } else {
            let val = this.processRuleName(ruleName, rule, [...list], currentPointer, content);
            if (val != null) {
                output.push(this.extractTextValue(val));
            }
        }
        return this.prepareOutput(output);
    }

	// eslint-disable-next-line max-params
    processRuleName(ruleName, rule, list, currentPointer, content) {
        let wildCard = ruleName === "*";

        if (wildCard === false && (currentPointer && (typeof currentPointer === "object" || typeof currentPointer === 'function') && !(Array.isArray(currentPointer)) && !(ruleName in currentPointer))) {
            // if currentPointer is object and doesn't contain ruleName
            return null;
        }

        if (!(currentPointer && (typeof currentPointer === "object" || typeof currentPointer === 'function'))) {
            // if currentPointer isn't object
            return null;
        }

        if (rule.rule && rule.rule.property !== undefined && rule.rule.value !== undefined) {
            // there is a property value selection as a rule -> split to two different items
            let list2 = [{name: rule.name}, rule.rule, ...list];
            if (Array.isArray(currentPointer)) {
                let result = [];
                for (let val of currentPointer) {
                    let out = this.processCommands(list2, val, content);
                    if (out !== undefined) {
                        result.push(out);
                    }
                }
                return result;
            } else {
                return this.processCommands(list2, currentPointer, content);
            }
        }

        if (rule.rule && rule.rule.selections !== undefined) {
            // there are more property value selection as a rule -> split to two different items
            let list2 = [{name: rule.name}, rule.rule, ...list];
            if (Array.isArray(currentPointer)) {
                let result = [];
                for (let val of currentPointer) {
                    let out = this.processCommands(list2, val, content);
                    if (out !== undefined) {
                        result.push(out);
                    }
                }
                return result;
            } else {
                return this.processCommands(list2, currentPointer, content);
            }
        }

        let value = rule.rule ? rule.rule(currentPointer[ruleName], content) : currentPointer[ruleName];
        if (wildCard === true) {
            value = [];
            for (let val of Object.keys(currentPointer)) {
                value.push(currentPointer[val]);
            }
        } else if (Array.isArray(currentPointer)) {
            value = [];
            for (let val of currentPointer) {
                value.push(val[ruleName]);
            }
        }

        if (Array.isArray(value)) {
            let output = [];
            for (let val of value) {
                let sub = this.processCommands([...list], val, content);
                if (sub !== null) {
                    output.push(this.extractTextValue(sub));
                }
            }
            return this.prepareOutput(output);
        } else {
            return this.processCommands([...list], value, content);
        }
    }

	// eslint-disable-next-line max-params
    processSelection(expression, list, currentPointer, content, currentVal) {
        let logicalOperator;
        let propertyValue;
        let expressionValue;
        let expressionOperator;
        if (Array.isArray(expression)) {
            if (expression.length !== 2) {
                throw new Error("Bad expression value", expression);
            }
            logicalOperator = expression[0];
            propertyValue = this.preparePropertyValue(expression[1].property, currentPointer);
            expressionValue = expression[1].value;
            expressionOperator = expression[1].operator;
        } else {
            propertyValue = this.preparePropertyValue(expression.property, currentPointer);
            expressionValue = expression.value;
            expressionOperator = expression.operator;
        }

        let ruleValue = this.prepareValue(expressionValue);
        if (expressionOperator === "eq") {
            expressionValue = propertyValue == ruleValue;
        } else if (expressionOperator === "like") {
            expressionValue = String(propertyValue).indexOf(ruleValue) !== -1;
        } else if (expressionOperator === "ne") {
            expressionValue = propertyValue != ruleValue;
        } else if (expressionOperator === "gt") {
            expressionValue = propertyValue > ruleValue;
        } else if (expressionOperator === "gte") {
            expressionValue = propertyValue >= ruleValue;
        } else if (expressionOperator === "lt") {
            expressionValue = propertyValue < ruleValue;
        } else if (expressionOperator === "lte") {
            expressionValue = propertyValue <= ruleValue;
        }

        if (logicalOperator === undefined) {
            currentVal = expressionValue;
        } else if (logicalOperator === '&&') {
            currentVal = currentVal && expressionValue;
        } else if (logicalOperator === '||') {
            currentVal = currentVal || expressionValue;
        }

        return currentVal;
    }

	// eslint-disable-next-line max-params
    processMultiSelection(rule, list, currentPointer, content) {
        let currentVal;
        if ("selections" in rule) {
            for (let expression of rule.selections) {
                currentVal = this.processSelection(expression, list, currentPointer, content, currentVal);
            }
        } else if ("property" in rule && "value" in rule) {
            currentVal = this.processSelection(rule, list, currentPointer, content, currentVal);
        }

        if (currentVal === true) {
            return this.processCommands([...list], currentPointer, content);
        }
        return null;
    }

    extractTextValue(value) {
        if (this.options && this.options.extractStrings === false) {
            return value;
        }

        if (value && typeof value === "object" && '_' in value) {
            return value['_'];
        } else if (value && typeof value === "object" && '$' in value && Object.keys(value).length === 1) {
            /*
             string required and object found
             $ found in this object and nothing else
             -> this produces xml2js and nothing will be produced
            */
            return undefined;
        }
        return value;
    }

    preparePropertyValue(ruleProperty, currentPointer) {
        let currentPointerValue;
        if (!Array.isArray(ruleProperty)) {
            ruleProperty = [ruleProperty];
        }

        currentPointerValue = currentPointer;
        for (let idx = 0; idx < ruleProperty.length; idx++) {
            let cur = ruleProperty[idx].trim();
            if (currentPointerValue[cur] === undefined && Array.isArray(currentPointerValue) && currentPointerValue.length === 1) {
                currentPointerValue = currentPointerValue[0];
            }

            currentPointerValue = currentPointerValue[cur]; // nosemgrep

            if (currentPointerValue === undefined) {
                return null;
            }
        }
        if (Array.isArray(currentPointerValue) && currentPointerValue.length === 1) {
            currentPointerValue = currentPointerValue[0];
        }
        if (typeof currentPointerValue === 'boolean') {
            currentPointerValue = "" + currentPointerValue;
        }

        return currentPointerValue;
    }

    prepareValue(value) {
        let result = value.trim();
        if (result) {
            if (result.startsWith("\"") || result.startsWith("'")) {
                result = result.substring(1);
            }
            if (result.endsWith("\"") || result.endsWith("'")) {
                result = result.substring(0, result.length - 1);
            }
        }
        return result;
    }

    prepareOutput(output) {
        if (output.length === 0) {
            return null;
        }
        if (output.length === 1) {
            return output[0];
        }
        return output;
    }
}

export default JSONPathParserHelper;
